import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ModalEndTourComponent } from '../modal-end-tour/modal-end-tour.component';
import { ProfileService } from 'src/app/services/profile.service';
import { BaseService } from 'src/app/services/base.service';
import { Subscription, Observable } from 'rxjs';
import { driver, DriveStep } from 'driver.js';
import { getShippingDeliveryStarterSteps, getShippingDeliveryEnterpriseSteps, getShippingCostSteps, getPaymentApiSteps, getQrislyApiSteps, getShippingCostStarterSteps, cleanUpAllTourStates } from '../../../../libs/helpers/tours';
import { ONBOARDING } from 'src/app/constants/endpoint.const';
import { OnboardingRequestType } from 'src/app/types/request/onboarding-request.type';

@Component({
  selector: 'app-modal-start-tour',
  standalone: false,
  templateUrl: './modal-start-tour.component.html',
  styleUrl: './modal-start-tour.component.scss'
})
export class ModalStartTourComponent implements OnInit, OnDestroy, OnChanges {
handleEndTour() {
throw new Error('Method not implemented.');
}
  @Input() isVisibleBanner: boolean = true;
  @Output() isVisibleBannerChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  nextStep: boolean = false;
  rajaongkirLevel: number | null | undefined = null;
  profileSubscription!: Subscription;

  constructor(
    private profileService: ProfileService,
    private router: Router,
    private modalService: NzModalService,
    private baseService: BaseService
  ) {}

  ngOnInit(): void {
    this.profileSubscription = this.profileService.profileData$.subscribe(data => {
      if (data) {
        this.rajaongkirLevel = data.rajaongkir_level;

        const email = data.email;
        if (email && data.is_new_user) {
          const tourKey = `has_seen_tour_${email}`;
          if (!sessionStorage.getItem(tourKey)) {
            setTimeout(() => {
              this.isVisibleBannerChange.emit(true);
              sessionStorage.setItem(tourKey, 'true');
            });
          }
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisibleBanner'] && changes['isVisibleBanner'].currentValue === true && !this.nextStep) {
      this.postOnboarding({ action: 'show_welcome' }).subscribe();
    }
  }

  getServiceName(productName: string): string {
    if (productName === 'API Shipping Delivery') {
      return this.rajaongkirLevel === 3 ? 'shipping_delivery_enterprise' : 'shipping_delivery_starter';
    }
    if (productName === 'API Shipping Cost') return 'shipping_cost';
    if (productName === 'API Payment') return 'payment';
    if (productName === 'QRISLY') return 'qrisly';
    return '';
  }

  ngOnDestroy(): void {
    if (this.profileSubscription) {
      this.profileSubscription.unsubscribe();
    }
  }

  productList: Array<{
    icon: string,
    name: string,
    desc: string
  }> = [
    {
      icon: 'https://storage.googleapis.com/komerce/rajaongkir/truck-bg-blue.svg',
      name: 'API Shipping Cost',
      desc: 'API untuk cek ongkir anti ribet.',
    },
    {
      icon: 'https://storage.googleapis.com/komerce/rajaongkir/box-bg-purple.svg',
      name: 'API Shipping Delivery',
      desc: 'Kelola pembuatan resi, pickup, dan pelacakan order.',
    },
    {
      icon: 'https://storage.googleapis.com/komerce/rajaongkir/card-bg-green.svg',
      name: 'API Payment',
      desc: 'Terima pembayaran otomatis via Virtual Account dan QRIS.',
    },
    {
      icon: 'https://storage.googleapis.com/komerce/rajaongkir/qris-bg-yellow.svg',
      name: 'QRISLY',
      desc: 'Ubah QRIS statis menjadi dinamis untuk kelola transaksi lebih praktis.',
    }
  ]

  handleStart(): void {
    this.nextStep = true;
  }

  handleProductClick(product: { name: string; icon: string; desc: string }): void {
    const service_name = this.getServiceName(product.name);
    this.postOnboarding({ action: 'start', service_name }).subscribe();
    this.handleCancel(true);

    setTimeout(() => {
      let currentStepIndex = 0;
      let totalSteps = 0;
      let isDestroying = false;

      const driverObj = driver({
        showProgress: true,
        allowClose: true,
        allowKeyboardControl: false,
        overlayClickBehavior: () => {},
        progressText: 'Langkah {{current}} dari {{total}}',
        nextBtnText: 'Selanjutnya &rarr;',
        prevBtnText: '<',
        doneBtnText: 'Selesai Tour',
        onPopoverRender: (popover, options) => {
          const state = options?.state;
          const closeBtn = popover.wrapper.querySelector('.driver-popover-close-btn') as HTMLElement;
          if (closeBtn) {
            closeBtn.setAttribute('tabindex', '-1');
          }
          let skipBtn = popover.footer.querySelector('.driver-skip-btn') as HTMLElement;
          if (!skipBtn) {
            skipBtn = document.createElement('button');
            skipBtn.className = 'driver-skip-btn';
            skipBtn.innerText = 'Skip';
            skipBtn.setAttribute('tabindex', '-1');
            skipBtn.style.cssText = 'background: white; border: 1px solid #E2E8F0; border-radius: 12px; padding: 8px 20px; color: #0F172A; font-weight: 500; cursor: pointer; font-size: 14px; margin-right: 12px; transition: all 0.2s ease;';
            skipBtn.onclick = () => {
              driverObj.destroy();
            };
            popover.footer.insertBefore(skipBtn, popover.footer.firstChild);
          }
          if (state?.activeStep?.popover?.showButtons?.length === 0) {
            skipBtn.style.display = 'none';
          } else {
            skipBtn.style.display = 'block';
          }
        },
        onHighlightStarted: (element, step, options) => {
          const activeIndex = options?.state?.activeIndex ?? 0;
          if (activeIndex > currentStepIndex) {
            currentStepIndex = activeIndex;
            this.postOnboarding({ action: 'next', step: activeIndex + 1, route: this.router.url, service_name }).subscribe();
          }

          if (element) {
            const submenu = element.closest('.ant-menu-submenu');
            if (submenu && !submenu.classList.contains('ant-menu-submenu-open')) {
              const title = submenu.querySelector('.ant-menu-submenu-title') as HTMLElement;
              if (title) {
                title.click();
              }
            }
          }
        },
        onDestroyed: (element, step, options) => {
          cleanUpAllTourStates();

          if (currentStepIndex === totalSteps - 1) {
            this.postOnboarding({ action: 'finish', step: currentStepIndex + 1, route: this.router.url, service_name }).subscribe();
          } else {
            this.postOnboarding({ action: 'skip', step: currentStepIndex + 1, route: this.router.url, service_name }).subscribe();
          }

          this.modalService.create({
            nzContent: ModalEndTourComponent,
            nzData: { serviceName: product.name },
            nzFooter: null,
            nzClosable: false,
            nzMaskClosable: false,
            nzCentered: true,
            nzWidth: 400
          });
        }
      });

      let steps: DriveStep[] = [];
      if (product.name === 'API Shipping Delivery') {
        if (this.rajaongkirLevel !== 3) {
          steps = getShippingDeliveryStarterSteps(this.router, driverObj);
        } else {
          steps = getShippingDeliveryEnterpriseSteps(this.router, driverObj);
        }
      } else if (product.name === 'API Shipping Cost') {
        steps = getShippingCostSteps(this.router, driverObj);
      } else if (product.name === 'API Payment') {
        steps = getPaymentApiSteps(this.router, driverObj);
      } else if (product.name === 'QRISLY') {
        steps = getQrislyApiSteps(this.router, driverObj);
      }

      totalSteps = steps.length;
      driverObj.setSteps(steps);

      // Prevent browser Back/Forward navigation & trackpad swipe gestures during tour
      document.documentElement.style.overscrollBehavior = 'none';
      document.documentElement.style.overscrollBehaviorX = 'none';
      document.body.style.overscrollBehavior = 'none';
      document.body.style.overscrollBehaviorX = 'none';

      // Track initial tour URL and route for history lock
      (window as any).__tourCurrentUrl = location.href;
      (window as any).__tourCurrentRouteUrl = this.router.url;

      if (!(window as any).__tourRouterSubscription) {
        (window as any).__tourRouterSubscription = this.router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
            const newUrl = location.href;
            (window as any).__tourCurrentUrl = newUrl;
            (window as any).__tourCurrentRouteUrl = event.urlAfterRedirects || event.url;

            // When tour steps navigate to a new route, pad history stack with 30 dummy entries for the NEW route
            for (let i = 0; i < 30; i++) {
              history.pushState({ tourLocked: true }, '', newUrl);
              (window as any).__tourPushCount = ((window as any).__tourPushCount || 0) + 1;
            }
          }
        });
      }

      if (!(window as any).__tourPopstateHandler) {
        let pushCount = 0;
        for (let i = 0; i < 30; i++) {
          history.pushState({ tourLocked: true }, '', (window as any).__tourCurrentUrl);
          pushCount++;
        }
        (window as any).__tourPushCount = pushCount;

        const handlePopState = (event: PopStateEvent) => {
          const targetUrl = (window as any).__tourCurrentUrl || location.href;
          history.pushState({ tourLocked: true }, '', targetUrl);
          (window as any).__tourPushCount = ((window as any).__tourPushCount || 0) + 1;

          if (driverObj && typeof driverObj.refresh === 'function') {
            setTimeout(() => {
              driverObj.refresh();
            }, 50);
          }
        };
        (window as any).__tourPopstateHandler = handlePopState;
        window.addEventListener('popstate', handlePopState);
      }

      if (!(window as any).__tourAuxClickHandler) {
        const handleAuxClick = (e: MouseEvent) => {
          if (e.button === 3 || e.button === 4) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        };
        (window as any).__tourAuxClickHandler = handleAuxClick;
        window.addEventListener('auxclick', handleAuxClick, true);
        window.addEventListener('pointerdown', handleAuxClick, true);
        window.addEventListener('mousedown', handleAuxClick, true);
      }

      if (!(window as any).__tourWheelHandler) {
        const handleWheel = (e: WheelEvent) => {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY) || Math.abs(e.deltaX) > 10) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        };
        (window as any).__tourWheelHandler = handleWheel;
        window.addEventListener('wheel', handleWheel, { passive: false, capture: true });
      }

      if (!(window as any).__tourTouchHandler) {
        let touchStartX = 0;
        let touchStartY = 0;
        const handleTouchStart = (e: TouchEvent) => {
          if (e.touches.length > 0) {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
          }
        };
        const handleTouchMove = (e: TouchEvent) => {
          if (e.touches.length > 0) {
            const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
            const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
            if (deltaX > deltaY && deltaX > 10) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          }
        };
        (window as any).__tourTouchHandler = { handleTouchStart, handleTouchMove };
        window.addEventListener('touchstart', handleTouchStart, { passive: true, capture: true });
        window.addEventListener('touchmove', handleTouchMove, { passive: false, capture: true });
      }

      // Block Enter, Space, Arrow, Alt+Nav, and Backspace keys from closing, skipping, or navigating the tour
      if (!(window as any).__tourKeyBlocker) {
        const blockKeyboardClose = (e: KeyboardEvent) => {
          const isEnter = e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13;
          const isSpace = e.key === ' ' || e.code === 'Space' || e.keyCode === 32;
          const isArrow = e.key?.startsWith('Arrow') || ['Left', 'Right', 'Up', 'Down', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key) || (e.keyCode >= 37 && e.keyCode <= 40);
          const isAltNav = e.altKey && (isArrow || e.key === 'ArrowLeft' || e.key === 'ArrowRight');
          const isBackspace = e.key === 'Backspace' || e.keyCode === 8;
          const target = e.target as HTMLElement;

          if (isAltNav) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }

          if (isBackspace) {
            if (!target || (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA')) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          }

          if (isArrow) {
            if (!target || (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA')) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          }

          if (isSpace) {
            if (!target || (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA')) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          }

          if (isEnter) {
            if (!target || target.classList.contains('driver-skip-btn') || target.classList.contains('driver-popover-close-btn') || target.closest('.driver-popover-close-btn') || target.closest('.driver-popover')) {
              if (target && target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
              }
            }
          }
        };
        (window as any).__tourKeyBlocker = blockKeyboardClose;
        window.addEventListener('keydown', blockKeyboardClose, true);
        window.addEventListener('keyup', blockKeyboardClose, true);
      }

      driverObj.drive();
    }, 300);
  }

  handleCancel(isFromStart: boolean = false): void {
    if (!this.nextStep && this.isVisibleBanner && !isFromStart) {
      this.postOnboarding({ action: 'skip_welcome' }).subscribe();
    }
    this.isVisibleBanner = false;
    this.nextStep = false;
    this.isVisibleBannerChange.emit(false);
  }

  postOnboarding(payload: Partial<OnboardingRequestType>): Observable<unknown> {
    return this.baseService.postData(ONBOARDING + '/logs', payload);
  }
}
